import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';

class AccountsSearchUserForm extends React.Component {
    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.accounts.forms.account_search_user') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.email') }
                                    name='email'
                                    validate={ [
                                        validations.required,
                                        validations.email,
                                    ] }
                                />
                            </Item>
                        </Row>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

AccountsSearchUserForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm(),
);

export default enhance(AccountsSearchUserForm);



// WEBPACK FOOTER //
// ./src/pages/accounts/create/AccountsSearchUserForm.js